import { Button, Card, type CardProps, Box, Flex, Text } from '@mantine/core'
import { useRouter } from 'next/router'
import React from 'react'

import { useTranslation } from '@flecto/translations'
import { iconInsuranceOn, Icon } from '@flecto/ui'

type CardBookingInsuranceEnableIntegrationProps = Omit<CardProps, 'children'>

export function CardBookingInsuranceEnableIntegration(
  props: CardBookingInsuranceEnableIntegrationProps
) {
  const { t } = useTranslation('saas', { keyPrefix: 'booking_insurances' })
  const { t: tActions } = useTranslation('shared', { keyPrefix: 'actions' })

  const router = useRouter()

  return (
    <Card {...props} withBorder>
      <Flex align='center' gap='md' justify='space-between'>
        <Icon
          icon={iconInsuranceOn}
          color='gray'
          size='md'
          withCircleBackground
          style={{ flexShrink: 0 }}
        />
        <Box style={{ flex: 1 }}>
          <Text fw={500}>{t('card_enable_integration_title')}</Text>
          <Text color='dimmed' size='sm'>
            {t('card_enable_integration_description')}
          </Text>
        </Box>
        <Button
          onClickCapture={() => router.push('/user/insurances')}
          variant='outline'
        >
          {tActions('know_more')}
        </Button>
      </Flex>
    </Card>
  )
}
